import React from "react"
import { useState, useCallback } from "react"
import config from "config"

import { GridDebug } from "components/grid"
import { MobileView, BrowserView } from "components/helpers/hide"

window.version = () => config.app.version

export const WindowDebug = () => {
  const [isDebug, setIsDebug] = useState<boolean>(false)
  const debug = useCallback(() => setIsDebug(!isDebug), [isDebug])

  window.debug = debug

  if (isDebug) {
    return (
      <>
        <BrowserView>
          <GridDebug />
        </BrowserView>
        <MobileView>
          <GridDebug mobile />
        </MobileView>
      </>
    )
  }

  return null
}

export default WindowDebug
